module.exports = __webpack_public_path__ + "static/media/5.b1ddc2f4.jpeg";